<template>
  <div id="slide-5" class="slide">
    <img src="../assets/images/tube-line-2.svg" alt="tube-line-2" class="line-img tube-line-2">
    <img src="../assets/images/mobile-line-1.svg" alt="mobile-line-1" class="mobile-line-img mobile-line">

    <div class="container slide-content">
      <div class="row">
        <div class="col-md-12">
          <h1 class="is-pink mb-3 center">Great, thank you.</h1>
          <p class="p-26 is-bold my-3 center">Please click on the button below to sign up</p>
          <div class="btn-wrap-tl">
            <a
              class="btn btn-purple"
              @click="changeSlide(6, $event)"
              href="https://www.london.gov.uk/talk-london/user/register?utm_source=lgov&utm_medium=&utm_campaign=YourCommute&utm_content=Join"
              target="_blank"
            >
              Join Talk London
            </a>
          </div>

        </div>
        <!-- <div class="col-md-12">
          <iframe
            src="https://www.london.gov.uk/talk-london/registration-service?target=https://www.london.gov.uk/talk-london"
            id="tl-iframe"
            frameborder="0"
            title="Talk London registration form"
            :class="{
              'gla-iframe': true,
              'closed': formSubmitted
            }"></iframe>
        </div> -->
      </div>
    </div>

    <div class="mob-line-wrap">
      <img src="../assets/images/line-3-mobile.svg" alt="mobile-line-2" class="mobile-line-img mobile-line-2">
    </div>

  </div>
</template>

<script>
export default {
  props: ['variantFormSubmitted'],
  data() {
    return {
      form: {
        email: ''
      },
      windowWidth: 0,
      formSubmitted: false
    }
  },

  computed: {
    actionText() {
      return this.windowWidth >= 768
        ? 'Please enter your details opposite to sign up:'
        : 'Please enter your details below to sign up:'
    }
  },

  methods: {
    changeSlide(i) {
      this.$emit('changeSlide', i);
      this.$ga.event('FA - data journey', 'Slide 4', 'Passed');
      this.$ga.event('FA - data journey', 'Form submitted', this.formSubmitted.toString());
    },

    getWindowWidth(event) {
      this.windowWidth = document.documentElement.clientWidth;
    },
  },

  mounted() {
    // window.addEventListener("message", (event) => {
    //   if (event.data === 'A new user has been registered.') {
    //     this.formSubmitted = true;
    //     this.changeSlide(6);
    //   }
    // });

    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth);
      this.getWindowWidth()
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  }
}
</script>

<style lang="scss" scoped>
  #tl-iframe.closed {
    min-height: 0;
  }
  #tl-iframe {
    min-height: 800px;
  }
  @media screen and (max-width: 768px) {
    #tl-iframe {
      min-height: 1000px;
    }
  }
  .form-container iframe {
    border: none;
    width: 100%;
    min-height: 200px;
  }
  .small {
    font-size: 12px;
    text-align: center;
    margin-top: 10px;
  }

  .form-container {
    border: 1px solid #e1e2e3;
    border-radius: 8px;
    background-color: #ffffff;
    padding: 53px 60px 35px;
  }

  .btn-wrapper {
    display: flex;
    margin: 0 -10px;
  }

  // .btn-purple,
  // .btn-gray {
  //   font-size: 22px;
  //   flex-grow: 1;
  //   margin: 20px 10px 0;
  //   padding: 12px 0;
  // }

  .tube-line-2 {
    position: absolute;
    left: 0;
    top: 0;
    max-width: 80%;
  }

  .form-group {
    margin-bottom: 30px;
  }

  .mobile-line {
    position: absolute;
    top: -70px;
    right: 0px;
  }

  .mob-line-wrap {
    position: relative;
    margin-top: 80px;
    height: 180px;
  }

  .mobile-line-2 {
    position: absolute;
    right: 0;
  }

  .center {
    text-align: center;
  }

  .gla-iframe {
    border: none;
    width: 100%;
  }

  .btn-wrap-tl {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }

  @media screen and (max-width: 900px) {
    .slide-content {
      margin-top: 90px;
    }

    .form-container {
      padding: 35px 20px;
    }
  }

  @media screen and (max-width: 767px) {
    .form-container {
      border: none;
      box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.1);
      padding: 30px 20px;
      margin-top: 10px;
    }

    // .btn-purple,
    // .btn-gray {
    //   padding: 17px 0;
    // }
  }
</style>



// WEBPACK FOOTER //
// src/components/Slide5.vue